import React from 'react';

const CTA = () => {
  return (
    <section className="relative py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Fondo con gradiente mejorado */}
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-salient-primary to-gray-200 opacity-95"></div>
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
        <div className="absolute -top-12 -left-12 w-64 h-64 rounded-full bg-white opacity-10"></div>
        <div className="absolute top-1/2 right-0 w-80 h-80 rounded-full bg-white opacity-5"></div>
        <div className="absolute bottom-0 left-1/3 w-40 h-40 rounded-full bg-white opacity-10"></div>
      </div>
      
      {/* Patrón de puntos */}
      <div className="absolute inset-0 z-0 opacity-10" 
        style={{ 
          backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
          backgroundSize: '20px 20px'
        }}>
      </div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        {/* Icono decorativo */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full flex items-center justify-center bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm">
            <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
        </div>

        {/* Título con sombra sutil */}
        <h2 className="text-4xl sm:text-5xl font-bold text-white mb-2 drop-shadow-sm">
          ¿Listo para transformar tu negocio?
        </h2>
        
        {/* Línea separadora */}
        <div className="w-16 h-1 bg-white bg-opacity-40 mx-auto my-6 rounded-full"></div>
        
        <p className="mt-4 text-xl sm:text-2xl text-white text-opacity-90 leading-relaxed font-light">
          Agenda una consultoría <span className="font-semibold">gratuita</span> y descubre cómo podemos 
          ayudarte a alcanzar tus objetivos.
        </p>
        
        {/* Contenedor de botones */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          {/* Botón principal con sombra y efecto hover */}
          <a
            href="/"
            className="group relative inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-gray-700 bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            <span className="mr-2">Contáctanos hoy</span>
            <svg className="w-5 h-5 transition-transform duration-300 transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
          
          {/* Botón secundario con borde más grueso */}
          <a
            href="/"
            className="mt-4 sm:mt-0 inline-flex items-center justify-center px-6 py-3 text-base font-medium rounded-full text-white border-2 border-white hover:bg-white hover:bg-opacity-10 transition-all duration-300"
          >
            Ver servicios
          </a>
        </div>
      </div>
      
    </section>
  );
};

export default CTA;